import { Box, Container, Grid, Paper, Step, StepIcon, StepLabel, Stepper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, StepIconProps, StepConnector, stepConnectorClasses, keyframes, Button } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import HomeIcon from '@mui/icons-material/Home';
import DataIcon from '@mui/icons-material/DownloadDone';
import SchudeIcon from '@mui/icons-material/Schedule';
import TaskIcon from '@mui/icons-material/TaskAlt';
import TruoraIcon from '@mui/icons-material/Photo';
import SignIcon from '@mui/icons-material/Grading';
import TextIcon from '@material-ui/icons/Forum';
import SuccessIcon from '@mui/icons-material/DoneOutline';
import NumbersIcon from '@mui/icons-material/Numbers';
import InputIcon from '@mui/icons-material/Input';

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../Constants";
import { axiosClient } from "../AxiosClient";
import { toBogotaParts } from "./solicitudFechaHora";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));



const steps = [
    {
        labels: ["Aceptación crédito", "Sector ocupación", "Aceptación canales comunicación", "Truora", "ZapSign", "Bienvenida"],
        icons: {
            1: <TextIcon></TextIcon>,
            2: <InputIcon></InputIcon>,
            3: <NumbersIcon></NumbersIcon>,
            4: <TruoraIcon></TruoraIcon>,
            5: <SignIcon></SignIcon>,
            6: <TaskIcon></TaskIcon>
        }
    }
]

const steppers = [
    {
        id: 1,
        steps: [
            {
                step: 0,
                labels: ["Aceptación crédito", "Revisión condiciones crédito"]
            },
            {
                step: 1,
                labels: ["Sector ocupación cliente"]
            },
            {
                step: 2,
                labels: ["Aceptación canales comunicación"]
            },
            {
                step: 3,
                labels: ["Documento frontal", "Documento dorsal", "Validación documento truora", "Truora documento", "Denegado Truora documento", "Validación manual truora", "Selfie", "Validación selfie truora"]
            },
            {
                step: 4,
                labels: ["Firma pagaré"]
            },
            {
                step: 3,
                labels: ["Mensaje bienvenida"]
            }
        ]
    }
]

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(52, 58, 95) 0%,rgb(132, 160, 133) 100%)',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(52, 58, 95) 0%,rgb(132, 160, 133) 100%)',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));

  const active = keyframes`
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
    100% {
        transform: translateY(0);
    }
  `

const ColorlibStepIconRoot = styled('div')((props) => {
    const { theme, ownerState } = props;
    return {
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
      zIndex: 1,
      color: '#fff',
      width: 50,
      height: 50,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      ...(ownerState.active && {
        backgroundImage:
          'linear-gradient( 136deg, rgb(52, 58, 95) 0%, rgb(166, 209, 170) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.5)',
        animation: `${active} 1.5s linear infinite`, 
      }),
      ...(ownerState.completed && {
        backgroundImage:
          'linear-gradient( 136deg, rgb(52, 58, 95) 0%, rgb(166, 209, 170) 100%)',
      }),
    };
  });

const iconStep = (props, icons) => {
    const {active, completed, className} = props;

    

    return (
        <ColorlibStepIconRoot ownerState={{completed, active}} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    )
}

var formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const validateTable = (step) => {
    const update = {
        id: -1,
        step: -1
    } 
    steppers.forEach(item => {
        item.steps.forEach(steps => {
            if(steps.labels.includes(step)) {
                update.id = item.id;
                update.step = steps.step
            }
        })
    })
    return update;
}

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px !important',
    gap: '10px !important',
    backgroundColor: '#161e55 !important',
    color: '#ffff !important',
    margin: '0px 1rem !important',
    '&:hover': {
        backgroundColor: '#A8C8AF !important',
    },
})

const urlApi = API_URL;
const conversations = {
    CLIENT: (documentNumber) => (`solicitudes/v4/conversacion/cliente/${documentNumber}`),
    COMMERCE: (cellphone) => (`solicitudes/v4/conversacion/comercio/${cellphone}`)
}

export default function StepperOption(props) {
    
    const {uuid} = useParams();
    const [requestProgress, setRequestProgress] = useState();
    const [steppersOne, setSteppersOne] = useState(-1);
    const [steppersSecond, setSteppersSecond] = useState(-1);
    const [steppersThird, setSteppersThird] = useState(-1);
    const [urlImgFront, setUrlImgFront] = useState("");
    const [urlImgPosterior, setImgPosterior] = useState("");
    const [truora, setTruora] = useState("");
    const navigate = useNavigate();

    const uploadImage = (keyImage, setImage) => {
        axiosClient.get(`/v1/s3/url/${keyImage}.jpg`)
        .then(response => {
            setImage(response.data);
        })
        .catch(error => {
            console.log("Error with Axios: " + error.message);
        });
    }

    const validationTruora = (documentNumber) => {
        axiosClient.post(`/v1/whatsapp-conversation/truora/${documentNumber}`)
        .then(response => {
            console.log(response.data);
        })
        .catch(error => {
            console.log("Error with Axios: " + error.message);
        });
    }

    useEffect(() => {
        axiosClient.get(`/v1/request-progress/${uuid}`)
        .then(response => {
            setRequestProgress(response.data);
            const res = response.data;

            if (res.conversation.frontDocumentId != null) {
                uploadImage(res.conversation.frontDocumentId, setUrlImgFront);
            }
            if (res.conversation.backDocumentId != null) {
                uploadImage(res.conversation.backDocumentId, setImgPosterior);
            }
            if (res.conversation.selfieId != null) {
                uploadImage(res.conversation.selfieId, setTruora);
            }

            const update = validateTable(res.conversation.descriptionStatus);
            switch (update.id) {
                case 1:
                    setSteppersOne(update.step);
                    setSteppersSecond(-1);
                    setSteppersThird(-1);
                    break;
                case 2:
                    setSteppersOne(steps[0].labels.length - 1);
                    setSteppersSecond(update.step);
                    setSteppersThird(-1);
                    break;
                case 3:
                    setSteppersOne(steps[0].labels.length - 1);
                    setSteppersSecond(steps[1].labels.length - 1);
                    setSteppersThird(update.step);
                    break;
                default:
                    setSteppersOne(-1);
                    setSteppersSecond(-1);
                    setSteppersThird(-1);
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });

    }, [])

    const updateTable = () => {
        axiosClient.get(`/v1/request-progress/${uuid}`)
        .then(response => {
            const res = response.data;
            setRequestProgress(res);

            if (res.conversation.frontDocumentId != null) {
                uploadImage(res.conversation.frontDocumentId, setUrlImgFront);
            }
            if (res.conversation.backDocumentId != null) {
                uploadImage(res.conversation.backDocumentId, setImgPosterior);
            }
            if (res.conversation.selfieId != null) {
                uploadImage(res.conversation.selfieId, setTruora);
            }

            const update = validateTable(res.conversation.descriptionStatus);
            switch (update.id) {
                case 1:
                    setSteppersOne(update.step);
                    setSteppersSecond(-1);
                    setSteppersThird(-1);
                    break;
                case 2:
                    setSteppersOne(steps[0].labels.length - 1);
                    setSteppersSecond(update.step);
                    setSteppersThird(-1);
                    break;
                case 3:
                    setSteppersOne(steps[0].labels.length - 1);
                    setSteppersSecond(steps[1].labels.length - 1);
                    setSteppersThird(update.step);
                    break;
                default:
                    setSteppersOne(-1);
                    setSteppersSecond(-1);
                    setSteppersThird(-1);
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    }

    const redirectConversion = (url) => {
        navigate(`/homeAdmin/${url}`);
    }

    console.log(requestProgress)

    return (
        <React.Fragment>
            <br></br>
            <Box sx={{width: '100%', marginTop: '1.7rem'}}>
                <Container>
                    <Item></Item>
                    <Item>.</Item>
                    <Grid container spacing={4} sx={{marginTop: '1rem', alignItems: 'center'}}>
                        <Grid item>
                            <h1>Solicitudes Creditop</h1>
                        </Grid>
                        <Grid item>
                            <ButtonAdd onClick={updateTable}>Actualizar</ButtonAdd>
                        </Grid>
                        <Grid item>
                            <ButtonAdd onClick={() => redirectConversion(conversations.CLIENT(requestProgress?.conversation?.documentNumber))}>Ver Conversación Cliente</ButtonAdd>
                        </Grid>
                        <Grid item>
                            <ButtonAdd onClick={() => redirectConversion(conversations.COMMERCE(requestProgress?.conversation?.commerceCellphone))}>Ver Conversación Comercio</ButtonAdd>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'space-between'} sx={{marginBottom: '1.8rem'}}>
                        <Grid item>
                            <p>{`Comercio: ${requestProgress?.commerce?.name}`}</p>
                            <p>{`Cel comercio: ${requestProgress?.conversation?.commerceCellphone}`}</p>
                            <p>{`Fecha incio: ${toBogotaParts(requestProgress?.conversation?.createdDate)?.date ?? ""}`}</p>
                            <p>{`Hora inicio flujo: ${toBogotaParts(requestProgress?.conversation?.createdDate)?.time ?? ""}`}</p>
                        </Grid>
                        <Grid item>
                            <p>{`Cédula cliente: ${requestProgress?.conversation.documentNumber}`}</p>
                            <p>{`Nombre cliente: ${requestProgress?.conversation.clientName} ${requestProgress?.conversation.clientLastName}`}</p>
                            <p>{`Paso: ${requestProgress?.conversation.descriptionStatus}`}</p>
                        </Grid>
                    </Grid>
                    <Grid container gap={10}>
                        <Stepper alternativeLabel activeStep={steppersOne} connector={<ColorlibConnector></ColorlibConnector>}>
                            {
                                steps[0].labels.map( (items, index) => 
                                (
                                    <Step key={items}>
                                        <StepLabel StepIconComponent={(props) => iconStep(props, steps[0].icons)}>{items}</StepLabel>
                                    </Step>
                                ))
                            }
                        </Stepper>
                    </Grid>
                    <Grid container sx={{margin: '1.5rem 1rem'}}>
                        <h2>Información</h2>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Parámetro</TableCell>
                                        <TableCell>Valor</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell>{requestProgress?.conversation?.clientName}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Apellido</TableCell>
                                        <TableCell>{requestProgress?.conversation?.clientLastName}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Fecha expedición</TableCell>
                                        <TableCell>{requestProgress?.conversation?.dateExpedition}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Celular</TableCell>
                                        <TableCell>{requestProgress?.conversation?.clientCellphone}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Ocupación</TableCell>
                                        <TableCell>{requestProgress?.conversation?.occupation}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Sector</TableCell>
                                        <TableCell>{requestProgress?.conversation?.occupationSector}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Descripción ocupación</TableCell>
                                        <TableCell>{requestProgress?.conversation?.descriptionOccupation}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Ingresos</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.clientEstimatedIncomes)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Gastos</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.averageCosts)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Dependientes</TableCell>
                                        <TableCell>{requestProgress?.conversation?.dependents}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Ingresos familiares</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.extraIncomes ? requestProgress?.conversation?.extraIncomes : 0)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Vivienda</TableCell>
                                        <TableCell>{requestProgress?.conversation?.houseType}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Arriendo</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.rentalValue ? requestProgress?.conversation?.rentalValue : 0)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Municipio</TableCell>
                                        <TableCell>{requestProgress?.conversation?.cityAddress}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Dirección</TableCell>
                                        <TableCell>{requestProgress?.conversation?.clientAddress}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Score</TableCell>
                                        <TableCell>{requestProgress?.conversation?.score}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Ingresos experian</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.incomesExperian)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Total cuotas</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.quotas)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Cerrados fin & cop</TableCell>
                                        <TableCell>{requestProgress?.conversation?.creditsFinanciero}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Cerrados real</TableCell>
                                        <TableCell>{requestProgress?.conversation?.creditsReal}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Cerrados Telco</TableCell>
                                        <TableCell>{requestProgress?.conversation?.creditsTelco}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Saldo actual</TableCell>
                                        <TableCell>{requestProgress?.conversation?.updateValue}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Max mora</TableCell>
                                        <TableCell>{requestProgress?.conversation?.mora}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Valor crédito</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.creditValue ? requestProgress?.conversation?.creditValue : 0)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Número cuotas</TableCell>
                                        <TableCell>{requestProgress?.conversation?.numberQuotas}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Valor cuotas</TableCell>
                                        <TableCell>{formatter.format(requestProgress?.conversation?.quotaValue ? requestProgress?.conversation?.quotaValue : 0)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Fecha de nacimiento</TableCell>
                                        <TableCell>{requestProgress?.conversation?.dateBirth}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Lugar de nacimiento</TableCell>
                                        <TableCell>{requestProgress?.conversation?.placeBirth}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid container textAlign={'center'} gap={'10px'} justifyContent={'center'}>
                            <Grid item>
                                <p>Documento frontal</p>
                                {urlImgFront != "" ? <img src={urlImgFront} alt="image" style={{width: '18vw'}}/> : ""}
                            </Grid>
                            <Grid item>
                                <p>Documento posterior</p>
                                {urlImgPosterior != "" ? <img src={urlImgPosterior} alt="image" style={{width: '18vw'}}/> : ""}
                            </Grid>
                            <Grid item>
                                <p>Foto</p>
                                {truora != "" ? <img src={truora} alt="image" style={{width: '18vw'}}/> : ""}
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </React.Fragment>
    )
}